import { render, staticRenderFns } from "./FormDomain.vue?vue&type=template&id=37bdf165&scoped=true"
import script from "./FormDomain.vue?vue&type=script&lang=js"
export * from "./FormDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bdf165",
  null
  
)

export default component.exports